import { put, call, select, takeLatest, race } from 'redux-saga/effects';
import { delay } from "redux-saga";
import {
  integration as inApis,
} from '../../api';
import { apiSaga } from '../../sagas';
import * as R from 'ramda';

function* checkJobStatus(payload) {
  let jobSucceeded = false;
  while (!jobSucceeded) {
    // delay the next polling request in 1 second
    yield call(delay, 4000);
    yield put({ type: '{integration-export}POLLING_ACTION_REQUEST' });
    const pollingAction = yield call(inApis.getJobStatus, { jobId: payload.jobId });
    switch (pollingAction.response.state) {
      case 'succeded':
        jobSucceeded = true;
        yield put({ type: '{integration-export} GET_PROCESSED_RESPONSE', payload: pollingAction.response.callbackResult });
        break;
      case 'failed':
        jobSucceeded = true;
        yield put({ type: '{integration-export} HANDLE_POLLING_FAILURE' });
        break;
      default:
        break;
    }
  }
}

function* startPolling({ payload }) {
  const { timeout } = yield race({
    response: call(() => checkJobStatus(payload)),
    timeout: call(delay, 60e3),
  });
  if (timeout) {
    yield put({ type: '{integration-export} HANDLE_POLLING_FAILURE', error: 'TOOOOO LOOOOOG' });
  }
}

export default [
  takeLatest('{integration-export} POLLING_ACTION_RESPONSE', startPolling),
];



// WEBPACK FOOTER //
// ./src/app/stores/integration/integration-sagas.js